import React from 'react';
import '../styles/About.css';

import headshot from '../assets/images/headshot.webp';

function About() {
  return (
    <div>
      <section id="about">
        <div className="section-stripe section-stripe--about" aria-hidden="true" />
        <div className="about-container">

          {/* Circular headshot — left side */}
          <div
            className="about-photo-wrap"
            data-aos="fade-right"
            data-aos-delay="100"
            data-aos-duration="1200"
            data-aos-offset="60"
            data-aos-once="false"
          >
            <img src={headshot} className="about-headshot" alt="Anaiysaa Deswal" loading="lazy" />
          </div>

          {/* Text — right side */}
          <div
            className="about-text"
            data-aos="fade-left"
            data-aos-delay="200"
            data-aos-duration="1200"
            data-aos-offset="60"
            data-aos-once="false"
          >
            <div className="about-header">Hi, I'm Anaiysaa!</div>
            <p>
              I'm a sophomore at Purdue University studying Computer Science and passionate about building technology that creates meaningful impact. I am specializing in Artificial Intelligence & Machine Learning, Computational Systems Engineering, and Software Engineering, with a strong interest in projects that bring together data, AI, and complex computing systems to solve real-world challenges.
            </p>
            <br />
            <p>
              Alongside my technical interests, I am pursuing a certificate in Entrepreneurship and Innovation, where I combine creative problem-solving with leadership and business strategy. These experiences have strengthened my ability to guide teams, give back through volunteering and mentorship, and make a lasting impact beyond the screen.
            </p>
            <br />
            <p>
              Outside of academics, I enjoy playing and listening to music, exploring art and design, and swimming — all of which help me stay inspired, balanced, and refreshed. Here's a look into my journey so far...
            </p>

            <div className="about-ender">Enjoy</div>
          </div>


        </div>
      </section>
    </div>
  );
}

export default About;
